/**
 * There are many menu items in the full version, so the sort values are extracted here for easier maintenance.
 *
 * Menu sorting: smaller values appear earlier, preferably incremented by a base of 10.
 */

export const home = 1;
export const access = 10;
export const routeNest = 20;

export const outside = 40;

export const exception = 90;
export const system = 100;
export const personalCenter = 110;
export const about = 120;
